var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ALL---2---Dashboard",
    transform: "translate(-1366.000000, -2230.000000)",
    fill: "#B6B8BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-vision",
    transform: "translate(1366.000000, 2230.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0 C5.151825,0 1.800225,2.48052294 0,6.15789474 C1.800225,9.83595929 5.151825,12.3157895 9,12.3157895 C12.848175,12.3157895 16.199775,9.83595929 18,6.15789474 C16.199775,2.48052294 12.848175,0 9,0 Z M9,10.0066078 C6.92865,10.0066078 5.249925,8.28372737 5.249925,6.15789474 C5.249925,4.0320621 6.92865,2.30918166 9,2.30918166 C11.07135,2.30918166 12.750075,4.0320621 12.750075,6.15789474 C12.750075,8.28372737 11.07135,10.0066078 9,10.0066078 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 6.15789474,
    r: 2.36842105
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.05a988b0a773e1729f38913ecb426eb5.svg";
export { ForwardRef as ReactComponent };